<template>
    <PageContent slug="products" />
</template>

<script setup>
import PageContent from './PageContent.vue'
</script>

